<script>
  import { onDestroy } from "svelte";

  import { activeStep } from "./stores/mainStore.js";
  import { userData } from "./stores/userStore.js";
  import { db } from "./firestore";
  import { signIn } from "./helper/UserHelper.js";

  let lastStep = 0; //$userData.data.lastStep;
  function get__store(store) {
    let $val;
    store.subscribe($ => ($val = $))();
    return $val;
  }

  const unsubscribe = activeStep.subscribe(value => {
    if (value <= lastStep) return; //only track moving forward
    lastStep = value;
    console.log(`active step changed -> tracking: ${lastStep}`);
    updateUserDoc({ lastStep: lastStep })
      .then(() => {
        console.log("Updated latest value");
      })
      .catch(error => {
        console.log("Error upating latest value:", error);
      });
  });

  const unsubscribe_2 = userData.subscribe(value => {
    if (value) {
      if (value.doc) {
        if (value.doc.lastStep != null) {
          lastStep = value.doc.lastStep;
        }
      }
    }
  });

  async function updateUserDoc(data) {
    return new Promise(async (resolve, reject) => {
      let userId;
      if ($userData == null) {
        /*Sign in*/
        const signInRes = await signIn(); //sign in user and creates user doc in sneak-peek main collection
        userId = signInRes.userId;
      } else userId = get__store(userData).user.uid;

      let docRef = db.collection("sneak-peek-users").doc(userId);
      // console.log(docRef)
      // resolve(null);
      return docRef
        .update(data)
        .then(function(result) {
          resolve(result);
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
          reject(error);
        });
    });
  }

  onDestroy(() => {
    unsubscribe();
    unsubscribe_2();
  });
</script>
